import en from './en.json'
import it from './it.json'

export const authTranslations = {
	en,
	it
} as const
